import { render, staticRenderFns } from "./FormGridLayout.vue?vue&type=template&id=ca533f86&"
import script from "./FormGridLayout.vue?vue&type=script&lang=js&"
export * from "./FormGridLayout.vue?vue&type=script&lang=js&"
import style0 from "./FormGridLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports